import React from "react";
import { Image } from "rbx";
import { getS3ImageUrl } from "../../../utils";

const renderImage = url =>
  url ? (
    <Image.Container size="square">
      <Image src={url} />
    </Image.Container>
  ) : null;

export const COMPANY_COLUMNS = [
  {
    Header: "Image",
    accessor: "ImageUrl",
    Cell: ({ cell }) => renderImage(getS3ImageUrl(cell.value))
  },
  {
    Header: "Company Id",
    accessor: "CompanyId"
  },
  {
    Header: "Name",
    accessor: "Name"
  },
  {
    Header: "Address 1",
    accessor: "Address1"
  },
  {
    Header: "Address 2",
    accessor: "Address2"
  },
  {
    Header: "City",
    accessor: "City"
  },
  {
    Header: "State",
    accessor: "State"
  },
  {
    Header: "Zip Code",
    accessor: "ZipCode"
  },
  {
    Header: "County",
    accessor: "County"
  },
  {
    Header: "Country",
    accessor: "Country"
  },
  {
    Header: "Phone No",
    accessor: "PhoneNo"
  },
  {
    Header: "Fax No",
    accessor: "FaxNo"
  },
  {
    Header: "Time Zone",
    accessor: "TimeZone",
    Cell: ({ cell }) => (cell.value ? cell.value.CodeDescription : null)
  },
  {
    Header: "Website",
    accessor: "Website"
  },
  {
    Header: "Currency",
    accessor: "LocalCurrency",
    Cell: ({ cell }) => (cell.value ? cell.value.CodeDescription : null)
  },
  {
    Header: "Active",
    accessor: "Active"
  }
];
export const LOCATION_COLUMNS = [
  {
    Header: "Name",
    accessor: "Name"
  },
  {
    Header: "Default Location",
    accessor: "DefaultLocation"
  },
  {
    Header: "Address 1",
    accessor: "Address1"
  },
  {
    Header: "Address 2",
    accessor: "Address2"
  },
  {
    Header: "City",
    accessor: "City"
  },
  {
    Header: "State",
    accessor: "State"
  },
  {
    Header: "Zip Code",
    accessor: "ZipCode"
  },
  {
    Header: "County",
    accessor: "County"
  },
  {
    Header: "Country",
    accessor: "Country"
  },
  {
    Header: "Phone No",
    accessor: "PhoneNo"
  },
  {
    Header: "Fax No",
    accessor: "FaxNo"
  },
  {
    Header: "Time Zone",
    accessor: "TimeZone",
    Cell: ({ cell }) => (cell.value ? cell.value.CodeDescription : null)
  },
  {
    Header: "Dispatch Terminal",
    accessor: "DispatchTerminalFlag"
  },
  {
    Header: "Inventory Location",
    accessor: "InventoryLocationFlag"
  },
  {
    Header: "Revenue",
    accessor: "RevGL",
    Cell: ({ cell }) => (cell.value ? cell.value.Description : null)
  },
  {
    Header: "Accounts Receivable",
    accessor: "ArGL",
    Cell: ({ cell }) => (cell.value ? cell.value.Description : null)
  },
  {
    Header: "Inventory",
    accessor: "InvGL",
    Cell: ({ cell }) => (cell.value ? cell.value.Description : null)
  },

  {
    Header: "Cost of Goods Sold",
    accessor: "CogsGL",
    Cell: ({ cell }) => (cell.value ? cell.value.Description : null)
  },
  {
    Header: "Active",
    accessor: "Active"
  }
];
